module.exports = __webpack_public_path__ + "img/stadia_controller_opsz20.cd36c539.svg";